export { positionElements, Positioning } from './ng-positioning'
export { PositioningService, PositioningOptions } from './positioning.service';



// WEBPACK FOOTER //
// ./~/angular-bootstrap-md/utils/positioning/index.ts